import $ from "jquery";
import Vue from "vue";
import * as ers from "../../../errorsmessages/errors";
import * as suc from "../../../successmessages/success";
import * as rt from "../../../routes/routes";
import * as ses from "../../../configurations/session/sessioncomplete";
import baseurl from "../../../configurations/baseurl/baseurl";
import router from "../../../router/index";

export const actions = {
  newTrucktracking() {
    let trucktrackingDetails = {
      requisition_id: $(".requisition_id").val(),
      tracking_date: $(".tracking_date").val(),
      truck_location: $(".truck_location").val(),
      remark: $('.remark').val(),
      email_address : $(".email_address").val(),
      email_subject: $(".email_subject").val(),
      email_message: $(".email_message").val()
    };
    $(".creatingTrucktracking").hide();
    $(".creatingTrucktrackingLoader").show();
    baseurl.post(rt.newTrucktracking, trucktrackingDetails).then(res => {
      $(".creatingTrucktracking").show();
      $(".creatingTrucktrackingLoader").hide();

      //checking response code from backend api

      if (res.data.code === 200) {
        //success code
        suc.truckCreateSuccess();
        router.push("/managerequisitions");
      } else if (res.data.code === 402) {
        //validation code
        ers.validateErrors();
      } else if (res.data.code === 403) {
        //truck tracking data exits
        ers.TruckExists();
      } else if (res.data.code === 404) {
        //error on saing data
        ers.errorCreatingTrucktracking();
      } else if (res.data.code === 405) {
        //no permission to create
        ers.noPermissionToCreate();
        router.push("/dashboard");
      } else if (res.data.code === 506) {
        //session expired
        ses.sessionComplete();
      }
    });
  },

  loadTrucktrackings({ commit }) {
    baseurl.get(rt.loadTrucktrackings).then(res => {
      $(".trucktrackingsLoader").hide();

      //checking response codes from backend api

      if (res.data.code === 200) {
        //success mutations
        commit("STORE_TRUCKTRACKINGS", res.data.trucktrackings);
      } else if (res.data.code === 404) {
        //error on loading data
        ers.errorLoadingTrucktracking();
      } else if (res.data.code === 405) {
        //no permission to read
        commit("STORE_TRUCKTRACKINGS", []);
        ers.noPermissionToRead();
        router.push("/dashboard");
      } else if (res.data.code === 506) {
        //session expired
        ses.sessionComplete();
      }
    });
  },

  viewTrucktracking({ commit }, trucktrackingId) {
    commit("STORE_TRUCKTRACKING_UPDATE", trucktrackingId);
    router.push("/updatetrucktracking");
  },

  updateTrucktracking({ commit }) {
    let trucktrackingDetails = {
      id: $(".id").val(),
      requisition_id: $(".requisition_id").val(),
      tracking_date: $(".tracking_date").val(),
      truck_location: $(".truck_location").val()
    };
    $(".updatingTrucktracking").hide();
    $(".updatingTrucktrackingLoader").show();
    baseurl.post(rt.updateTrucktracking, trucktrackingDetails).then(res => {
      $(".updatingTrucktracking").show();
      $(".updatingTrucktrackingLoader").hide();

      //checking response code from backend api

      if (res.data.code === 200) {
        //success code
        commit("STORE_TRUCKTRACKINGS", res.data.trucktrackings);
        suc.trucktrackingUpdateSuccess();
        setTimeout(() => {
          router.push("/managetrucktrackings");
        }, 3000);
      } else if (res.data.code === 402) {
        //validation code
        ers.validateErrors();
      } else if (res.data.code === 404) {
        //error on updating data
        ers.errorUpdatingTrucktracking();
      } else if (res.data.code === 405) {
        //no permission to update
        ers.noPermissionToUpdate();
        router.push("managetrucktrackings");
      } else if (res.data.code === 506) {
        //session expired
        ses.sessionComplete();
      }
    });
  },
  emailChange(){
    (function() {
      $('.email').change(function(){
        $('.email').hide();
        $('.' + $(this).val()).show();
      });
    });
  }
};
export default actions;



// WEBPACK FOOTER //
// ./src/vuex/modules/trucktrackings/actions.js